import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {Breadcrumb, Button, Card, Col, Descriptions, Divider, Row, Skeleton, Space, Table, Tooltip,} from "antd";
import moment from "moment";
import DrawerTradePoint from "../../dictionary/trade-point/trade-point/drawer_trade_point";
import DB_Returns from "../../../database/mobile/db_returns";
import {TradePointModel} from "../../../model/trade_point_model";
import BackButton from "../../tech/back_button";
import {EditOutlined} from "@ant-design/icons";

const Return = () => {
    const {return_id} = useParams()
    const {token, user, defaultPageSize, setToken} = useContext(Context)
    const {getReturn} = DB_Returns(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const navigate = useNavigate()
    const p = new URLSearchParams(window.location.search)
    const location = useLocation()
    const path = location.state == null ? null : (location.state.path == null ? null : location.state.path)
    const from = location.state == null ? null : (location.state.from == null ? null : location.state.from)
    const controller = new AbortController()
    const [wait, setWait] = useState(false)
    const [openDrawerTradePoint, setOpenDrawerTradePoint] = useState(false)


    let [returns] = useState({
        date: null,
        org_structure: null,
        comment: null,
        price_list: null,
        sum_price: 0,
        sum_weight: 0,
    })

    let [data, setData] = useState({
        returns: returns,
        trade_point: TradePointModel,
        details: []
    })

    const columns = [
        {
            title: t('#'),
            dataIndex: 'id',
        },
        {
            title: t('code'),
            dataIndex: 'vendor_code_id',
        },
        {
            title: t('vendor_code'),
            dataIndex: 'vendor_code',
        },

        {
            title: t('count'),
            dataIndex: 'count',
        },
        {
            title: t('price'),
            dataIndex: 'price',
        },
        {
            title: t('sum'),
            dataIndex: 'sum',
        },
    ]

    useEffect(() => {
        window.scroll(0, 0)
        if (wait) {
            controller.abort()
        }
        setWait(true)
        if (return_id != null) {
            getReturn(controller, return_id)
                .then(res => {
                    setData(res.data)
                    console.log(res.data)
                    setWait(false);
                })
                .catch((e) => {
                    if (!axios.isCancel(e)) {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    }
                })
        }
    }, [])

    const EditButton = () => {
        // if (user.role_id === 1) {
        return (
            <Tooltip placement={'bottomRight'} title={t('edit_return')}>
                <Link to={`edit`}>
                    <Button
                        icon={<EditOutlined />}
                        style={{margin: '0 5pt'}}
                    />
                </Link>

            </Tooltip>
        )
        // }
    }

    const ModifiedInvoice = () => {
        if (data.returns.ulm != null) {
            return (
                <Tooltip placement={'bottom'} title={t('modified_return', {user: data.returns.ulm, date: moment(data.returns.dlm).format('DD.MM.YYYY HH:mm')})}>
                    <span style={{color:'red', cursor:'pointer'}}>*</span>
                </Tooltip>
            )
        }
    }


    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('return')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                        {/*<Link key='1' to={from ? from :*/}
                        {/*    path ? `/mobile_app/returns?${path}` : "/mobile_app/returns"}>*/}
                        {/*    <Button type={'default'} shape={'round'}>{t('back')}</Button>*/}
                        {/*</Link>*/}
                    </Space>
                </Space>
                <Card
                    title={<>{t('return_id')} <br/> {data.returns.id} <ModifiedInvoice/></> }
                    extra={[
                        <EditButton key={1}/>,
                    ]}
                >
                    <Skeleton loading={wait} active>
                        <Descriptions>

                            <Descriptions.Item label={t('date_create')} span={3}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{moment(data.returns.date).format("DD.MM.YYYY HH:mm")}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('branch')} span={1}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.returns.branch}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('trade_point')} span={2} >
                                <Button type={'link'} style={{height:'auto', padding:'0'}} onClick={e => setOpenDrawerTradePoint(true)}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}} >{data.trade_point.name}</span>
                                </Button>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('price_list')} span={1}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.returns.price_list}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('org_structure')} span={2}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.returns.org_structure}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('comment')} span={3}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.returns.comment}</span>
                            </Descriptions.Item>

                        </Descriptions>
                    </Skeleton>
                    <Divider/>

                    <Table
                        columns={columns}
                        dataSource={data.details}
                        rowKey="vendor_code_id"
                        loading={wait}
                        pagination={false}
                        size={"small"}
                        style={{'--cursor': "auto" }}
                    />

                    <Card bordered={false}>
                        <Skeleton loading={wait} active>
                            <Row gutter={8}>
                                <Col span={4} offset={16} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <p>{t('total_weight')}</p>
                                </Col>
                                <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}}>{data.returns.sum_weight}</span>
                                </Col>
                            </Row>

                            <Row gutter={8}>
                                <Col span={4} offset={16} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <p>{t('total_price')}</p>
                                </Col>
                                <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}}>{data.returns.sum_price}</span>
                                </Col>
                            </Row>
                        </Skeleton>
                    </Card>
                </Card>
            </div>
            <Outlet/>

            <DrawerTradePoint
                trade_point={data.trade_point}
                show={openDrawerTradePoint}
                setShow={setOpenDrawerTradePoint}/>
        </>
    )
}

export default Return